import script from "./ToastNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastNotification.vue?vue&type=script&setup=true&lang=js"

import "./ToastNotification.vue?vue&type=style&index=0&id=0397f0f8&lang=scss"

const __exports__ = script;

export default __exports__